import React from 'react';
import { useTranslation } from 'react-i18next';
import './Contact.css';

function Contact() {
  const { t } = useTranslation();

  const contactInfo = [
    {
      icon: '📞',
      label: t('contact.phone'),
      value: '(503) 7997 7903',
      href: 'tel:+50379977903',
      color: 'var(--color-turquoise)'
    },
    {
      icon: '✉️',
      label: t('contact.email'),
      value: 'gingerasberry@gmail.com',
      href: 'mailto:gingerasberry@gmail.com',
      color: 'var(--color-lime-green)'
    },
    {
      icon: '📍',
      label: t('contact.location'),
      value: 'Based in El Tunco with fully international presence',
      href: 'https://maps.google.com/?q=El+Tunco+El+Salvador',
      color: 'var(--color-rose-gold)'
    }
  ];

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="section-header animate-fade-in-up">
          <h2>{t('contact.title')}</h2>
          <p className="section-description">
            {t('contact.getInTouch')}
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-grid">
              {contactInfo.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  target={item.href.startsWith('http') ? '_blank' : undefined}
                  rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                  className="contact-item animate-fade-in-up"
                  style={{'--contact-color': item.color}}
                >
                  <div className="contact-icon-container">
                    <div className="contact-icon">{item.icon}</div>
                    <div className="contact-glow"></div>
                  </div>
                  <div className="contact-details">
                    <h3>{item.label}</h3>
                    <p>{item.value}</p>
                  </div>
                </a>
              ))}
            </div>

            <div className="international-presence animate-fade-in-up">
              <div className="presence-visual">
                <div className="globe">🌍</div>
                <div className="radio-waves">
                  <div className="wave-ring"></div>
                  <div className="wave-ring"></div>
                  <div className="wave-ring"></div>
                </div>
              </div>
              <div className="presence-text">
                <h3>International Reach</h3>
                <p>Broadcasting from El Tunco, the international capital of El Salvador, to listeners around the globe</p>
              </div>
            </div>
          </div>

          <div className="contact-cta animate-fade-in-up">
            <div className="cta-content">
              <h3>Connect with Radio Tunco</h3>
              <p>Whether you're an artist, collaborator, or music lover, we'd love to hear from you</p>
              <div className="connection-methods">
                <div className="method-item">
                  <span className="method-icon">🎵</span>
                  <span>Submit Music</span>
                </div>
                <div className="method-item">
                  <span className="method-icon">🤝</span>
                  <span>Collaborate</span>
                </div>
                <div className="method-item">
                  <span className="method-icon">📻</span>
                  <span>Partner with Us</span>
                </div>
                <div className="method-item">
                  <span className="method-icon">💬</span>
                  <span>Just Say Hi</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer className="site-footer">
          <div className="footer-content">
            <div className="footer-logo">
              <h3>Radio Tunco</h3>
              <p>24/7 International Radio • Podcasts • NFT Music</p>
            </div>
            <div className="footer-links">
              <a href="#radio">Radio</a>
              <a href="#parties">Parties</a>
              <a href="#podcasts">Podcasts</a>
              <a href="#record-label">Music</a>
              <a href="#social">Social</a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Radio Tunco. All rights reserved. • El Tunco, El Salvador</p>
          </div>
        </footer>
      </div>
    </section>
  );
}

export default Contact;